import { render, staticRenderFns } from "./MyTextMoney.vue?vue&type=template&id=15f98d18&"
import script from "./MyTextMoney.vue?vue&type=script&lang=js&"
export * from "./MyTextMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports